export const CheckExternalLink = (urlSelect) => {
  const origin = window.location.origin;

  return !urlSelect.includes(origin);
};
